import client from "./client";

const BASE = "/v1/sales";

export const listCustomers = async (params = {}) =>
  (await client.get(`${BASE}/customers`, { params })).data;
export const createCustomer = async (body) => (await client.post(`${BASE}/customers`, body)).data;
export const getCustomer = async (id) => (await client.get(`${BASE}/customers/${id}`)).data;
export const updateCustomer = async (id, body) => (await client.patch(`${BASE}/customers/${id}`, body)).data;
export const putAddresses = async (id, body) => (await client.put(`${BASE}/customers/${id}/addresses`, body)).data;

export const listDocs = async (params = {}) => (await client.get(`${BASE}/docs`, { params })).data;
export const createDoc = async (body) => (await client.post(`${BASE}/docs`, body)).data;
export const getDoc = async (id) => (await client.get(`${BASE}/docs/${id}`)).data;
export const openQuantities = async (id, field) =>
  (await client.get(`${BASE}/docs/${id}/open-quantities`, { params: { field } })).data;
export const openDeliveries = async () => (await client.get(`${BASE}/docs/open-deliveries`)).data;

export const quotationAction = async (id, action, body = {}) =>
  (await client.post(`${BASE}/actions/quotations/${id}/${action}`, body)).data;
export const orderAction = async (id, action, body = {}) =>
  (await client.post(`${BASE}/actions/orders/${id}/${action}`, body)).data;
export const createDelivery = async (body) => (await client.post(`${BASE}/actions/deliveries`, body)).data;
export const deliveryAction = async (id, action, body = {}) =>
  (await client.post(`${BASE}/actions/deliveries/${id}/${action}`, body)).data;
